import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Observable } from "rxjs";
import { resolveApiUrl } from '../functions';

// an interceptor does something to a request before it leaves
export class AuthInterceptorService implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const url = resolveApiUrl(req.url);

        // withCredentials ensures the httpOnly session cookie is sent on every request
        const modifiedReq = req.clone({ url, withCredentials: true });
        return next.handle(modifiedReq);
    }
}
